import {Component, EventEmitter, Inject, OnInit, Output, ViewChild} from '@angular/core';
import {ConfirmationService, MessageService} from "primeng/api";
import {Calendar} from "primeng/calendar";
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AlertService, AuthenticationService, ConstantService} from "@app/_services";
import {ReservationService} from "@app/_components/reservation";
import {Router} from "@angular/router";
import {PropertyService} from "@app/_components/property";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import * as moment from "moment";
import {OwnerStmtService} from "@app/_components/owner-statements/owner-stmt.service";

@Component({
    selector: 'app-statement-create',
    templateUrl: './statement-create.component.html',
    styleUrls: ['./statement-create.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class StatementCreateComponent implements OnInit {

  @ViewChild('checkInDateCal') public checkInDateCalender: Calendar;
  @ViewChild('checkOutDateCal') public checkOutDateCalender: Calendar;

  @Output() doUpdate = new EventEmitter<any>();
  @Output() doCloseDialog = new EventEmitter<any>();

  //For reservation list to be shown on dialog
  formTitle: String;
  reservation: any;
  showCreateReservationPopUp = false;

  // forms
  form1: UntypedFormGroup;
  form2: UntypedFormGroup;
  form3: UntypedFormGroup;
  formLoading = false;
  formAlert: String;

  updatedCheckInDate: Date;
  checkOutDateBasedOnCheckinDate: Date;
  isDateLessThanCheckinDate = false;
  isDisplayClearDates = false;
  minDate: Date;
  maxDate: Date;

  validationMessages = {
    orderId: [],
    shortTermRentalId: [{ type: 'required', message: 'Required' }],
    month: [{ type: 'required', message: 'Required' }],
    year: [{ type: 'required', message: 'Required' }],
  };

  validationMessages2 = {
    month: [{ type: 'required', message: 'Required' }],
    year: [{ type: 'required', message: 'Required' }],
  };

  validationMessages3 = {
    shortTermRentalId: [{ type: 'required', message: 'Required' }],
    startDate: [{ type: 'required', message: 'Required' }],
    endDate: [{ type: 'required', message: 'Required' }],
  };
  referralSources: any[];
  properties: any[] = [];
  months: any[];
  readOnlySubmitBotton = false;
  openNewTab: any;
  years: any[];
  reservationTypes: any[];
  showBulkGenerateForm = false;
  showGenerateFormByDate = false;
  showGenerateForm = false;
  yearsForBulkGenerateStatement: any[];
  monthsForBulkGenerateStatement: any[];

  constructor(
    public authenticationService: AuthenticationService,
    public reservationService: ReservationService,
    public ownerStmtService: OwnerStmtService,
    public alertService: AlertService,
    public constantService: ConstantService,
    private messageService: MessageService,
    private formBuilder: UntypedFormBuilder,
    private confirmationService: ConfirmationService,
    public router: Router,
    private propertyService: PropertyService,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.formTitle = "Generate Statement",
      this.reservation = data.reservation;
    this.openNewTab = data.openNewTab;
    this.showBulkGenerateForm = data.showBulkGenerateForm;
    this.showGenerateFormByDate = data.showGenerateFormByDate;
    this.showGenerateForm = data.showGenerateForm;
    this.referralSources = this.reservationService.referralSources;
    this.months = this.ownerStmtService.months;
    this.yearsForBulkGenerateStatement = this.ownerStmtService.yearsForBulkGenerateStatement;
    this.monthsForBulkGenerateStatement = this.ownerStmtService.monthsForBulkGenerateStatement;
    this.years = this.ownerStmtService.years;
    this.reservationTypes = this.reservationService.reservationTypes;
  }

  ngOnInit(): void {
    this.fetchProperties();
    let today = new Date();
    let month = today.getMonth();
    let year = today.getFullYear();
    let day = today.getDate();
    this.updatedCheckInDate = today;
    this.minDate = new Date();
    this.maxDate = new Date(year + 3, month, day);
    this.formBuild();
    this.formBuild2();
    this.formBuild3();
  }

  fetchProperties() {
    try {
      this.formLoading = true;
      this.propertyService.propertySummaryForShortData()
        .subscribe(
          res => {
            // console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
            this.properties = res.data.properties;
            this.formLoading = false;
            // this.form1.patchValue(this.reservation);
          },
          err => {
            console.log('Feature-Update FAIL: ' + JSON.stringify(err));
            this.formLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
          },
          () => {  });
    } catch (error) {
      console.log('Form Invalid: ' + JSON.stringify(error));
      this.alertService.error(error);
    }
  }

  formBuild() {
    this.form1 = this.formBuilder.group({
      orderId: [this.reservation?.orderId],
      shortTermRentalId: ['', Validators.required],
      month: [2, Validators.required],
      year: [0],
    });
  }

  formBuild2() {
    this.form2 = this.formBuilder.group({
      month: [0, Validators.required],
      year: [0, Validators.required],
    });
  }

  formBuild3() {
    this.form3 = this.formBuilder.group({
      shortTermRentalId: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
    });
  }

  // Create reservation method
  createReservation() {
    try {
      // stop here if form is invalid
      this.form1.markAllAsTouched();
      if (this.form1.invalid) {
        return;
      }

      let reservationRequest = this.form1.value;


      this.readOnlySubmitBotton = true;
      this.formLoading = true;
      this.ownerStmtService.generateStatement(reservationRequest)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Generate Statement Successful" });
              // this.router.navigate(['/owner-statements/'])
              this.doUpdate.emit();
          },
          (err: any) => {
            // Do NOT reset formLoading or readOnlySubmitBotton on error — a 504 means the backend
            // may have already generated the statement. Keep button disabled to block re-submit.
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Statement generation may have completed. Please refresh before retrying.' });
            console.log('statement-generate FAIL: ' + JSON.stringify(err));
          },
          () => { this.formLoading = false; });

    } catch (error) {
      this.readOnlySubmitBotton = false;
      this.formLoading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
    }
  }

  // if select checkin date at that time checkout date set as null
  onKeyDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
    // this.form1.patchValue({
    // 	checkOutDate: ""
    // });
  }

  // if select checkout date at that time check checkin date must be below lessthan one day of selected date
  onKeyDateForCheckOutDate(event: any) {
    event.target.value = event.target.value.replace(/^(\d{2})(\d{2})(\d{4})/, '$1-$2-$3');
    if (this.form1.value.checkInDate) {
      let today = new Date(this.form1.value.checkInDate);
      this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
      this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
    }
  }

  // compare checkin and checkout dates
  compareDate(date: any) {
    this.isDateLessThanCheckinDate = false;
    if (Date.parse(date.target.value) < Date.parse(moment(this.checkOutDateBasedOnCheckinDate).format("MM/DD/YYYY"))) {
      this.isDateLessThanCheckinDate = true;
    }
  }

  // open guest modal
  openGuestModal(e: any) {
    // this.dropdown.show();
  }

  // change checking date
  checkInChange(e: any) {
    let today = new Date(e.valueOf());
    this.updatedCheckInDate = new Date(today.setDate(today.getDate() + 1));
    this.checkOutDateBasedOnCheckinDate = this.updatedCheckInDate;
    this.isDisplayClearDates = true;
    // this.form1.patchValue({
    // 	checkOutDate: ""
    // });
    window.setTimeout(() => {
      this.checkOutDateCalender.inputfieldViewChild.nativeElement.focus();
    }, 1);
  }

  // change checkout date
  checkOutChange(e: any) {
    this.isDisplayClearDates = true;
    // this.guestDropdownCount.show();
  }


  // Generate Bulk Statement method
  generateBulkStatement() {
    try {
      // stop here if form is invalid
      this.form2.markAllAsTouched();
      if (this.form2.invalid) {
        return;
      }
      this.readOnlySubmitBotton = true;
      this.formLoading = true;
      this.doCloseDialog.emit();
      this.ownerStmtService.generateBulkStatement(this.form2.value.month, this.form2.value.year)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Generate Bulk Statement Successful" });
              this.router.navigate(['/owner-statements/'])
              // this.doUpdate.emit();
          },
          (err: any) => {
            // Do NOT reset formLoading or readOnlySubmitBotton on error — a 504 means the backend
            // may have already generated bulk statements. Keep button disabled to block re-submit.
            console.log('statement-generate FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Bulk statement generation may have completed. Please refresh before retrying.' });
          },
          () => { });

    } catch (error) {
      this.readOnlySubmitBotton = false;
      this.formLoading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
    }
  }


  // Create reservation method
  generateStatementByDate() {
    try {
      // stop here if form is invalid
      this.form3.markAllAsTouched();
      if (this.form3.invalid) {
        return;
      }
    this.form3.value.startDate = moment(this.form3.value.startDate).format("YYYY-MM-DD");
    this.form3.value.endDate = moment(this.form3.value.endDate).format("YYYY-MM-DD");
      let reservationRequest = this.form3.value;

      this.readOnlySubmitBotton = true;
      this.formLoading = true;
      this.ownerStmtService.generateStatementByDate(reservationRequest)
        .subscribe(
          (res: any) => {
            this.formLoading = false;
              this.messageService.add({ severity: 'success', summary: 'Success', detail: "Generate Statement Successful" });
              this.router.navigate(['/owner-statements/'])
              this.doUpdate.emit();
          },
          (err: any) => {
            // Do NOT reset formLoading or readOnlySubmitBotton on error — a 504 means the backend
            // may have already generated the statement. Keep button disabled to block re-submit.
            console.log('statement-generate FAIL: ' + JSON.stringify(err));
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Statement generation may have completed. Please refresh before retrying.' });
          },
          () => { });

    } catch (error) {
      this.readOnlySubmitBotton = false;
      this.formLoading = false;
      this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
    }
  }


}
